var React = require('react');

function Database (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 4.571v2.857c0 2.518-6.271 4.571-14 4.571S0 9.945 0 7.428V4.571C0 2.053 6.271 0 14 0s14 2.054 14 4.571zM28 11v6.429C28 19.947 21.729 22 14 22S0 19.946 0 17.429V11c3.008 2.071 8.513 3.036 14 3.036S24.992 13.072 28 11zm0 10v6.429C28 29.947 21.729 32 14 32S0 29.946 0 27.429V21c3.008 2.071 8.513 3.036 14 3.036S24.992 23.072 28 21z"}));
}

Database.defaultProps = {"viewBox":"0 0 28 32"};

module.exports = Database;

Database.default = Database;
